export default function LinkRenderer({
  data: { link, meta },
}: {
  data: {
    link: string;
    meta: {
      description?: string;
      image?: { url: string };
      title?: string;
    };
  };
  className?: string;
}) {
  try {
    return (
      <div className="widget preview-link">
        <a
          href={link}
          className="preview-link__holder"
          target="_blank"
          rel="noreferrer"
        >
          <div className="preview-link__data">
            {meta.title && meta.title?.length > 0 && (
              <div className="preview-link__title">{meta.title}</div>
            )}

            {meta.description && meta.description?.length > 0 && (
              <div className="preview-link__text">{meta.description}</div>
            )}

            {link.length > 0 && (
              <div className="link link-blank preview-link__link">
                <i className="link__text">{link}</i>
                <span className="icon icon-arrow-blank link__icon" />
              </div>
            )}
          </div>
          {meta.image && meta.image?.url && (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              className="preview-link__pic"
              src={meta.image.url}
              alt={meta.title}
              width={64}
              height={64}
            />
          )}
        </a>
      </div>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет Link: ${error}`);
    return <></>;
  }
}
